import { t } from 'i18next';
import { regExp } from './regExp';

export interface UseDataValidations {
  isLetter: (text: string) => boolean;
  maxTextLenght: (stringToCheck: string, max: number) => string | undefined;
  minTextLenght: (stringToCheck: string, min: number) => string | undefined;
  textLenghtBetween: (stringToCheck: string, min: number, max: number) => string | undefined;
  compareEqualsObjects: <T>(object1: T, object2: T) => boolean;
  validateCalification: (stringToCheck: string) => boolean;
  isEmailError: (emailString: string) => string | false;
  fieldsAreEquals: (valueOfField1: string | undefined, valueOfField2: string | undefined, fieldName?: string) => string | false;
  isIdentificationError: (identification: string) => string | false;
  isNameError: (name: string) => string | false;
  isLastNameError: (lastName: string) => string | false;
  isPhoneError: (phone: string) => string | false;
  isValidApprovalDate: (selectedDate: string) => boolean;
  getMessageYearValid: () => string
}

export const useDataValidations = (): UseDataValidations => {
  const isLetter = (text: string) => {
    return regExp.alphabet.test(text);
  };
  const maxTextLenght = (stringToCheck: string, max: number) => {
    const error = `${t('exededMaxLenghthOf')} ${max}`;
    if (typeof max === 'number' && typeof stringToCheck === 'string') {
      const size = stringToCheck.split('').length;
      if (size < max + 1) return undefined;
      return error;
    }
    return undefined;
  };

  const minTextLenght = (stringToCheck: string, min: number) => {
    const error = `${t('minimumCharacterSize')} ${min}`;
    if (typeof min === 'number' && typeof stringToCheck === 'string') {
      const size = stringToCheck.split('').length;
      if (size > min - 1) return undefined;
      return error;
    }
    return undefined;
  };

  const textLenghtBetween = (stringToCheck: string, min: number, max: number) => {
    const error = `${t('characterMustBeBetween')} ${min} ${t('and')} ${max}`;
    if (typeof min === 'number' && typeof max === 'number' && typeof stringToCheck === 'string') {
      if (!minTextLenght(stringToCheck, min) && !maxTextLenght(stringToCheck, max)) return undefined;
      return error;
    }
    return undefined;
  };

  const compareEqualsObjects = <T>(object1: T, object2: T): boolean => {
    const json1 = JSON.stringify(object1);
    const json2 = JSON.stringify(object2);
    return json1 === json2;
  };

  const validateCalification = (stringToCheck: string) => {
    return regExp.onlyValidGrade.test(stringToCheck);
  };

  const isEmailError = (emailString: string) => {
    if (regExp.email.test(emailString)) {
      return false;
    }
    return t('invalidEmail');
  };

  const fieldsAreEquals = (valueOfField1: string | undefined, valueOfField2: string | undefined, fieldName = '') => {
    if (valueOfField1?.trim() === valueOfField2?.trim()) {
      return false;
    }
    return t('fieldsNoMatch', { field: fieldName });
  };

  const isIdentificationError = (identification: string) => {
    if (regExp.identification.test(identification)) {
      return false;
    }
    return t('InvalidIdentification');
  };

  const isNameError = (name: string) => {
    if (regExp.name.test(name)) {
      return false;
    }
    return t('invalidName');
  };
  const isLastNameError = (lastName: string) => {
    if (regExp.lastName.test(lastName)) {
      return false;
    }
    return t('invalidLastName');
  };

  const isPhoneError = (phone: string) => {
    if (regExp.phone.test(phone)) {
      return false;
    }
    return t('invalidPhoneAR');
  };

  const isValidApprovalDate = (_selectedDate: string) => {
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setHours(fromDate.getHours() - 24);
    fromDate.setFullYear(fromDate.getFullYear() - 100);
    const selectedDate = new Date(_selectedDate + 'T00:00:00');
    return toDate >= selectedDate && fromDate <= selectedDate;
  };

  const getMessageYearValid = () => {
    const fromDate = new Date();
    fromDate.setHours(fromDate.getHours() - 24);
    fromDate.setFullYear(fromDate.getFullYear() - 100);
    const dateForMessage: string = fromDate.toLocaleString().split(',')[0];
    return t('invalidDateMessage', { dateForMessage });
  };

  return {
    maxTextLenght,
    minTextLenght,
    textLenghtBetween,
    compareEqualsObjects,
    validateCalification,
    isEmailError,
    isIdentificationError,
    isNameError,
    isPhoneError,
    isLastNameError,
    isValidApprovalDate,
    isLetter,
    fieldsAreEquals,
    getMessageYearValid
  };
};
